import { AxiosResponse } from "axios";
import api from './Api'

const productionAccessTokenKey = 'positivehotel-yoga-client-accessToken';
const developmentAccessTokenKey = 'dev-positivehotel-yoga-client-accessToken';
const localAccessTokenKey = 'local-positivehotel-yoga-client-accessToken';

export const getLocalAccessToken = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        let accessToken = localStorage.getItem(productionAccessTokenKey);
        if (accessToken === 'undefined' || !accessToken) return null;
        return accessToken;
    } else if (process.env.REACT_APP_ENV === 'development') {
        const accessToken = localStorage.getItem(developmentAccessTokenKey);
        if (accessToken === 'undefined' || !accessToken) return null;
        return accessToken;
    } else if (process.env.REACT_APP_ENV === 'local') {
        const accessToken = localStorage.getItem(localAccessTokenKey);
        if (accessToken === 'undefined' || !accessToken) return null;
        return accessToken;
    }
    return null;
};
export const updateLocalAccessToken = (newAccessToken: string) => {
    const accessToken = localStorage.getItem("positivehotel-yoga-client-accessToken");
    if (accessToken === 'undefined' || !accessToken) return setUser(newAccessToken);
    localStorage.setItem("positivehotel-yoga-client-accessToken", newAccessToken);
};
export const setUser = (accessToken: string) => {
    if (process.env.REACT_APP_ENV === 'production') {
        localStorage.setItem(productionAccessTokenKey, accessToken);
    } else if (process.env.REACT_APP_ENV === 'development') {
        localStorage.setItem(developmentAccessTokenKey, accessToken);
    } else if (process.env.REACT_APP_ENV === 'local') {
        localStorage.setItem("local-positivehotel-yoga-client-accessToken", accessToken);
    }
};
export const removeUser = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        localStorage.removeItem(productionAccessTokenKey);
    } else if (process.env.REACT_APP_ENV === 'development') {
        localStorage.removeItem(developmentAccessTokenKey);
    } else if (process.env.REACT_APP_ENV === 'local') {
        localStorage.removeItem(localAccessTokenKey);
    }
};

export const validateToken = (): Promise<AxiosResponse<IMember>> => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/jwt`)
}